module.exports = __webpack_public_path__ + "img/logos.bad9432e.png";